import { createSelector } from "@ngrx/store";
import {
  AccountsState,
  CURRENT_ACCOUNT_LOCAL_STORAGE_KEY,
} from "./accounts.interface";
import {
  AccountActions,
  CHANGE_ACCOUNT,
  CHANGE_ACCOUNT_SUCCESS,
  FETCH_AVAILABLE_ACCOUNT_SUCCESS,
  RESET_ACCOUNT_SUCCESS,
} from "./accounts.actions";

export const accountsStateName = "accounts";
export const initialState: AccountsState = {
  currentAccount:
    window.localStorage.getItem(CURRENT_ACCOUNT_LOCAL_STORAGE_KEY) || undefined,
  availableAccounts: [],
};

export function accountsReducer(
  state: AccountsState = initialState,
  action: AccountActions,
): AccountsState {
  switch (action.type) {
    case CHANGE_ACCOUNT:
      return { ...state, currentAccount: action.payload };
    case CHANGE_ACCOUNT_SUCCESS:
      return { ...state, currentAccount: action.payload };
    case RESET_ACCOUNT_SUCCESS:
      return { ...state, currentAccount: undefined };
    case FETCH_AVAILABLE_ACCOUNT_SUCCESS:
      return { ...state, availableAccounts: action.payload.clients };

    default: {
      return state;
    }
  }
}

export const getAccountsState = (state: {
  [accountsStateName]?: AccountsState;
}) => state?.[accountsStateName];

export const getCurrentAccountState = (state: AccountsState) =>
  state?.currentAccount;
export const getAvailableAccountsState = (state: AccountsState) =>
  state?.availableAccounts;

export const getCurrentAccount = createSelector(
  getAccountsState,
  getCurrentAccountState,
);
export const getAvailableAccountsSelector = createSelector(
  getAccountsState,
  getAvailableAccountsState,
);
